import { gql } from "apollo-boost";
import { FileFragment } from "../fragments";

export const GET_PRINTIFY_AVAIABLE_SHOPS = gql`
    query getPrintifyAvaiableShops($apiKey: String!) {
        getPrintifyAvaiableShops(apiKey: $apiKey) {
            id
            salesChannel
            title
        }
    }
`;

export const GET_PRINTIFY_PRODUCT_PRINT_PROVIDERS = gql`
    query getPrintifyProductPrintProviders($productID: String!) {
        getPrintifyProductPrintProviders(productID: $productID) {
            id
            title
        }
    }
`;

export const GET_PRINTIFY_PRODUCT_PRINT_PROVIDER_VARIANTS = gql`
    query getPrintifyProductPrintProviderVariants(
        $productID: String!
        $printProviderID: String!
    ) {
        getPrintifyProductPrintProviderVariants(
            productID: $productID
            printProviderID: $printProviderID
        ) {
            id
            title
            variants {
                id
                title
                options
                placeholders
            }
        }
    }
`;

export const GET_DREAMSHIP_PRODUCT_PROVIDER_VARIANTS = gql`
    query getDreamshipProductProviderVariants($productBaseID: ID!) {
        getDreamshipProductProviderVariants(productBaseID: $productBaseID)
    }
`;

export const GET_CUSTOMCAT_PRODUCT_PROVIDER_VARIANTS = gql`
    query getCustomcatProductProviderVariants($productBaseID: ID!) {
        getCustomcatProductProviderVariants(productBaseID: $productBaseID)
    }
`;

export const GET_PRINTWAY_PRODUCT_DETAIL = gql`
    query getPrintwayProductDetail($productCode: String!) {
        getPrintwayProductDetail(productCode: $productCode)
    }
`;

export const GET_PRINTWAY_SHIPPING_METHODS = gql`
    query getPrintwayShippingMethods($variantSKUs: [String!]!) {
        getPrintwayShippingMethods(variantSKUs: $variantSKUs) {
            itemSKU
            shippingServices {
                code
                name
            }
        }
    }
`;

export const GET_CUSTOMCAT_VARIANTS_BY_FF_PRODUCT_ID = gql`
    query getCustomcatVariantsByFFProductId($id: String!) {
        getCustomcatVariantsByFFProductId(id: $id)
    }
`;

export const GET_GEARMENT_PRODUCTS_INFO = gql`
    query getGearmentProductsInfo {
        getGearmentProductsInfo
    }
`;

export const FETCH_GEARMENT_PRODUCT_DETAIL_V3 = gql`
    query fetchGearmentProductDetailV3(
        $apiKey: String
        $apiSignature: String
        $originID: String!
    ) {
        fetchGearmentProductDetailV3(
            apiKey: $apiKey
            apiSignature: $apiSignature
            originID: $originID
        ) {
            title
            description
            id
            attributes {
                name
                slug
                options
            }
            variants {
                fulfillmentProductId
                sorting
                salePrice
                sellerPrice
                regularPrice
                attributes {
                    name
                    slug
                    option
                }
            }
        }
    }
`;

export const GET_DREAMSHIP_PRODUCT_INFO = gql`
    query getDreamshipProductInfo($id: String!) {
        getDreamshipProductInfo(id: $id)
    }
`;

export const GET_MERCHIZE_PRODUCT_INFO = gql`
    query GetMerchizeProductInfo($id: String!) {
        getMerchizeProductInfo(id: $id)
    }
`;

export const GET_TEEZILY_PRODUCT_DETAIL = gql`
    query getTeezilyProductDetail($reference: String!) {
        getTeezilyProductDetail(reference: $reference)
    }
`;

export const GET_MERCHIZE_PRODUCT_INFO_DB = gql`
    query getMerchizeProductInfoFromDB($id: String!) {
        getMerchizeProductInfoFromDB(id: $id) {
            id
            originId
            title
            description
            attributes {
                name
                slug
                options
            }
            variants {
                fulfillmentProductId
                salePrice
                regularPrice
                sellerPrice
                sorting
                attributes {
                    name
                    slug
                    option
                }
            }
        }
    }
`;

export const GET_FULFILLMENTS = gql`
    query fulfillments {
        fulfillments {
            id
            name
            slug
        }
    }
`;

export const GET_SHIPPING_OPTION_BY_BASE = gql`
    query getShippingOptionByBase($productBaseID: ID!) {
        getShippingOptionByBase(productBaseID: $productBaseID) {
            id
            name
        }
    }
`;

export const GET_DREAMSHIP_SHOPS = gql`
    query getDreamshipShops {
        getDreamshipShops {
            id
            name
            key
        }
    }
`;

export const GET_BURGERPRINTS_PRODUCT = gql`
    query getBurgerPrintsProduct($shortCode: String!) {
        getBurgerPrintsProduct(shortCode: $shortCode)
    }
`;

export const FULFILLMENTS_INSTALLED = gql`
    query fulfillmentsInstalled {
        fulfillmentsInstalled {
            id
            name
            slug
        }
    }
`;

export const GET_PRINTBELLE_PRODUCT = gql`
    query getPrintBelleProduct($productCode: String!) {
        getPrintBelleProduct(productCode: $productCode) {
            title
            description
            attributes {
                name
                slug
                options
            }
            variants {
                regularPrice
                salePrice
                sellerPrice
                fulfillmentProductId
                sorting
                attributes {
                    name
                    slug
                    option
                }
            }
        }
    }
`;

export const GET_FULFILLMENT_PRODUCT_MOCKUP_BY_PRODUCT = gql`
    query getFulfillmentProductMockupByProduct($productId: ID!) {
        getFulfillmentProductMockupByProduct(productId: $productId) {
            id
            productId
            type
            file {
                ...FileFragment
            }
        }
    }
    ${FileFragment}
`;

export const FULFILLMENT_PRODUCT_BY_ID = gql`
    query fulfillmentProductById($filter: FulfillmentProductByIDFilter!) {
        fulfillmentProductById(filter: $filter) {
            total
            nodes {
                id
                title
                originId
                status
                description
                attributes {
                    name
                    slug
                    options
                }
                variants {
                    regularPrice
                    salePrice
                    sellerPrice
                    fulfillmentProductId
                    sorting
                    attributes {
                        name
                        slug
                        option
                    }
                }
                fulfillmentSkus
                printAreas
                type
            }
        }
    }
`;
